import { getSubdomain } from '../../../../../packages/kiti/utils/helpers/url'
import window from '../../../../../utils/helpers/window'
import { useOpenEditIntegrationTokenModal } from '../../../../../utils/routes/modals/modalsActions'

export const onInstallService = (config, openModal) => {
  openModal('integrations/twilio', config, 'Nova integração')

  return
}

export const useReinstallService = (config, openModal) => {
  const openTokenModal = useOpenEditIntegrationTokenModal()

  return ({ id }) => {
    openTokenModal({ ...config, integrationId: id })
  }
}
